import { Query } from '@datorama/akita';
import { SessionState, SessionStore } from './session.store';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SessionQuery extends Query<SessionState> {
  allState$ = this.select();
  selectName$ = this.select((state) => state.user.givenName + ' ' + state.user.surName);
  selectEmail$ = this.select((state) => state.user.email);

  constructor(protected override store: SessionStore) {
    super(store);
  }
}
